import { Button } from "primereact/button";
import React, { useEffect, useState, useRef, useContext } from "react";
import TextInput from "./TextInput";
import { TabPanel, TabView } from "primereact/tabview";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import InputTextArea, { InputNum } from "./InputTextArea";
import { FileUpload } from "primereact/fileupload";
import PoliticalPartyService from "../services/PoliticalPartyService";
import DocumentTypesService from "../services/DocumentsService";
import imageToBase64 from "image-to-base64/browser";
import { Image } from "primereact/image";
import { PrimeIcons } from "primereact/api";
import UseError from "./UseError";
import { AppDB } from "../App";
import { Checkbox } from "primereact/checkbox";
import GenericFileCapture from "./GenericFileCapture";
import GenericUploadFileTable from "./GenericUploadFileTable";
import { setTimeToMidnightUTC } from "../config/Config";
export default function AddPoliticalParty({ setShow, show, canRefresh = () => { } }) {
	var { permission, toast, lookUp } = useContext(AppDB);
	var [loading, setLoading] = useState(false);
	var [showFileUploader, setShowFileUploader] = useState(false);
	var [fileUploaderDocuments, setFileUploaderDocuments] = useState([])
	var [refresh, setRefresh] = useState(false);
	var [firstSubmit, setFirstSubmit] = useState(false);
	var [politicalDocumentTypes, setPoliticalDocuments] = useState([]);

	var raw_form = {
		name: "",
		description: "",
		abbreviation: "",
		slogan: "",
		registeredDate: "",
		annivesary: null,
		logo: "",
		logoExtension: "png",
		logoContentType: "",
		"termYears": "",
		"termStartDate": "",
		"termEndDate": "",
		documents: [],
		emailAddress: ""
	};

	var [form, setForm] = useState(raw_form);
	var { SetFormError, updateForm, formErrors } = UseError();
	var [formErrorMessage, setFormErrorMessage] = useState({});
	useEffect(() => {
		SetFormError({
			emailAddress: "required|email",
			name: "required|limit:200",
			description: "required|limit:200",
			abbreviation: "required|limit:200",
			// slogan: "required|limit:200",
			registeredDate: "required|limit:200",
			logo: "required",
			termYears: "required",
			termStartDate: "required",
		});
	}, []);

	var documentService = new DocumentTypesService();
	useEffect(() => {
		documentService.getDocumentTypes(1).then(res => {
			setPoliticalDocuments(res)
		})

	}, [])

	async function onInputChange(event, extra = {}) {
		var name = event?.target?.name;
		console.log(event?.value || event?.target?.value);

		await setForm({ ...form, [name]: event?.value || event?.target?.value.toUpperCase(), ...extra });
		var res = await updateForm(name, event?.value || event?.target?.value, form);
		if (res.trim().length === 0) {
			await delete formErrorMessage[name];
			setFormErrorMessage({ ...formErrorMessage });
		} else {
			setFormErrorMessage({ ...formErrorMessage, [name]: res });
		}
	}

	const inputFileRef = useRef(null);
	const constitutionFileRef = useRef(null);
	const societyActRegisteredFileRef = useRef(null);

	const onBtnClick = () => {
		inputFileRef.current.click();
	};

	const onBtnConstitutionClick = () => {
		constitutionFileRef.current.value = ""
		constitutionFileRef.current.click();
	};
	const onBtnSocietyActRegisteredClick = () => {
		societyActRegisteredFileRef.current.value = ""
		societyActRegisteredFileRef.current.click();
	};

	var convertBase64 = (file) => {
		return new Promise((resolve, reject) => {
			const fileReader = new FileReader();
			fileReader.readAsDataURL(file);
			fileReader.onload = () => {
				resolve(fileReader.result);
			};
			fileReader.onerror = (error) => {
				reject(error);
			};
		});
	};

	async function onUploadHandler(e) {
		const file = e.files[0];
		const base64 = await convertBase64(file);
		var base64result = base64;
		await delete formErrorMessage.logo;
		setFormErrorMessage({ ...formErrorMessage });
		const extension = file.name.split(".").pop();
		setForm({ ...form, logo: base64result, logoExtension: extension, logoContentType: file.type });
	}

	async function onConstitutionUploadHandler(e) {
		const file = e.files[0];
		const base64 = await convertBase64(file);
		var base64result = base64;
		await delete formErrorMessage.constitution;
		setFormErrorMessage({ ...formErrorMessage });
		const extension = file.name.split(".").pop();
		setForm({
			...form,
			constitution: base64result,
			constitutionFileName: file.name,
			constitutionExtension: extension,
			constitutionContentType: file.type
		});
	}

	async function onSocietyActRegisteredUploadHandler(e) {
		const file = e.files[0];
		const base64 = await convertBase64(file);
		var base64result = base64;
		await delete formErrorMessage.constitution;
		setFormErrorMessage({ ...formErrorMessage });
		const extension = file.name.split(".").pop();
		setForm({
			...form,
			societyActRegistration: base64result,
			societyActRegistrationFileName: file.name,
			societyActRegistrationExtension: extension,
			societyActRegistrationContentType: file.type,
			societyActRegistration_error: ""
		});
	}

	async function SubmitForm() {
		setFirstSubmit(true);

		var error = {};
		var haveError = false;
		for (let key in formErrors) {
			if (formErrors.hasOwnProperty(key)) {
				var res = await updateForm(key, form[key], form);
				if (res.length > 2) {
					console.log(key, res);
					haveError = true;
					error[key] = res;
				}
			}
		}


		if (getMissingCategoryNames().length > 0) {
			haveError = true;
		}

		await setFormErrorMessage({ ...formErrorMessage, ...error });
		if (form.societyActRegistered === true) {

			if (form.societyActRegistration.length === 0) {
				toast.show({
					severity: "error",
					detail: "Please fill in all required fields",
					life: 2500
				});
				setForm({ ...form, societyActRegistration_error: "is required" })
				return;
			}
		}
		if (haveError) {
			return toast.show({
				severity: "error",
				detail: "Please fill in all required fields",
				life: 2500
			});
		}

		setLoading(true);

		var PoliticalParty = new PoliticalPartyService();
		form.documents = fileUploaderDocuments;

		var clone = JSON.parse(JSON.stringify(form));
		console.log(new Date(clone.registeredDate).toISOString())

		clone.registeredDate = setTimeToMidnightUTC(clone.registeredDate)
		clone.termStartDate = setTimeToMidnightUTC(form.termStartDate)
		clone.termEndDate = setTimeToMidnightUTC(form.termEndDate)

		var cloneImageLogo = clone.logo.split(",");
		if (cloneImageLogo.length >= 2) {
			clone.logo = cloneImageLogo[1];
		}


		clone.documents.map(doc => {
			var _do = doc.binaryData.split(",");
			if (_do.length >= 2) {
				doc.binaryData = _do[1];
			}
			return doc;
		})

		console.log(clone)

		PoliticalParty.createParty(clone)
			.then((res) => {
				console.log(res);
				if (res.success) {
					setLoading(false);
					setShow(false);
					setForm(raw_form);
					canRefresh();
					toast.show({
						severity: "success",
						detail: "Political Party Created",
						life: 2500
					});
				} else {
					setLoading(false);
					toast.show({
						severity: "error",
						detail: res.message,
						life: 2500
					});
				}
			})
			.catch((e) => {
				console.log(e);
				setLoading(false);
				return toast.show({
					severity: "error",
					summary: "Error",
					detail: "Ooops, The is a technical problem,Please Try Again",
					life: 2000
				});
			});
	}

	function calculateAnniversary(registeredDate) {
		// Get today's date
		let today = new Date(registeredDate);

		// Add 12 months
		today.setMonth(today.getMonth() + 12);

		// Format the date as YYYY-MM-DD
		return today;
	}
	function calculateEndDate(startDate, years) {
		const date = new Date(startDate); // Convert input to Date object
		date.setFullYear(date.getFullYear() + parseInt(years)); // Add years
		return date;
	}


	function getMissingCategoryNames() {
		var requiredTypes = [1, 5, 8, 3, 11];
		var doc = fileUploaderDocuments;
		var documentCategories = politicalDocumentTypes;

		const existingIDs = doc.map(d => d.documentTypeID);
		const missingTypeIDs = requiredTypes.filter(id => !existingIDs.includes(id));

		// Check if documentCategories has all the requiredTypes
		const categoryIDs = documentCategories.map(cat => cat.id);
		const missingInCategories = requiredTypes.filter(id => !categoryIDs.includes(id));

		if (missingInCategories.length > 0) {
			// Return early if any requiredTypes are not found in documentCategories
			return [{ name: "Missing required types in political party categories", missingTypeIDs: missingInCategories }];
		}

		// Otherwise return names of missing categories
		return documentCategories
			.filter(cat => missingTypeIDs.includes(cat.id))
			.map(cat => ({ name: cat.name }));
	}




	return (
		<Dialog
			draggable={false}
			header={
				<>
					<li className="pi pi-plus"> </li>
					<span> Add Political Party</span>
				</>
			}
			footer={
				<>
					<Button onClick={SubmitForm} className="p-button-success" type="button" label={"Submit"} loading={loading} />
					<Button className="p-button-danger" onClick={() => {
						setShow(false)
						setFirstSubmit(false)
					}
					} label="Close" />
				</>
			}
			visible={show}
			onHide={(e) => {
				setShow(false)
				setFirstSubmit(false)
			}
			}
			style={{ width: "95%", height: "90%" }}
		>
			<div className="grid">
				<div className="col-12 lg:col-12">
					<div method="post">
						<TabView>
							<TabPanel header="Political Party Details">
								<div className="grid">
									{/* <div className="col-12  lg:col-4">
										<Checkbox
											id="societyActRegistered"
											checked={form.societyActRegistered}
											name="societyActRegistered"
											label="societyActRegistered"
											required={true}
											value={form.societyActRegistered}
											optionLabel="abbreviation"
											onChange={(e) => setForm({ ...form, societyActRegistered: e.checked })}
										/>
										<label htmlFor="societyActRegistered" className="ml-2">Registered under society's act</label>
									</div> */}
									<div className="col-12  lg:col-4">
										<TextInput
											message={formErrorMessage}
											name="name"
											label="Name"
											required={true}
											optionLabel="Name"
											value={form.name}
											onChange={(e) => onInputChange(e)}
										/>
									</div>
									<div className="col-12  lg:col-4">
										<TextInput
											message={formErrorMessage}
											name="abbreviation"
											label="Abbreviation"
											required={true}
											value={form.abbreviation}
											optionLabel="abbreviation"
											onChange={(e) => onInputChange(e)}
										/>
									</div>
									<div className="col-12  lg:col-4">
										<TextInput
											message={formErrorMessage}
											name="registeredDate"
											type="Calendar"
											label="Date Registered"
											required={true}
											value={form.registeredDate}
											onChange={(e) => {
												onInputChange(e);
												setTimeout(() => {
													setForm({
														...form,
														registeredDate: e.value,
														// annivesary: calculateAnniversary(new Date(e.value))
													});
												}, 500);
											}}
										/>
									</div>
									{/* <div className="col-12  lg:col-4">
										<TextInput
											disabled={false}
											value={form.annivesary}
											name={"annivesary"}
											type="Calendar"
											label="Annivesary"
											required={false}
											onChange={(e) => onInputChange(e)}
										/>
									</div> */}
									<div className="col-12  lg:col-4">
										<InputTextArea
											message={formErrorMessage}
											name={"description"}
											rows="2"
											cols="61"
											required={true}
											label="Description Of Official Symbol"
											value={form.description}
											optionLabel="description"
											onChange={(e) => onInputChange(e)}
										/>
									</div>
									{/* <div className="col-12  lg:col-4">
										<InputTextArea
											message={formErrorMessage}
											name="slogan"
											rows="2"
											cols="61"
											label="Slogan"
											required={true}
											value={form.slogan}
											optionLabel="slogan"
											onChange={(e) => onInputChange(e)}
										/>
									</div> */}
									<div className="col-12  lg:col-4">
										<TextInput
											message={formErrorMessage}
											name="emailAddress"
											rows="2"
											cols="61"
											label="Official Party Email Address"
											required={true}
											value={form.emailAddress}
											optionLabel="emailAddress"
											onChange={(e) => onInputChange(e)}

										/>
									</div>
									<div className="col-12  lg:col-4">
										<InputNum
											message={formErrorMessage}
											name="termYears"
											rows="2"
											cols="61"
											label="Term Years"
											required={true}
											value={form.termYears}
											optionLabel="termYears"
											onChange={(e) => {
												onInputChange(e, { termStartDate: "", termEndDate: "" })
											}}
										/>
									</div>
									{![""].includes(form.termYears) && (<>
										<div className="col-12  lg:col-4">
											<TextInput
												message={formErrorMessage}
												name="termStartDate"
												type="Calendar"
												label="Term Start Date"
												required={true}
												value={form.termStartDate}
												onChange={(e) => {
													onInputChange(e, { termEndDate: calculateEndDate(new Date(e.value), form.termYears) });

												}}
											/>
										</div>
										<div className="col-12  lg:col-4">
											<TextInput
												type="Calendar"
												disabled={true}
												message={formErrorMessage}
												name="termEndDate"
												rows="2"
												cols="61"
												label="Term End Date"
												required={true}
												value={form.termEndDate}
												optionLabel="Term End Date"
												onChange={(e) => onInputChange(e)}
											/>
										</div>
									</>)}
								</div>

								<div className="grid">
									<div className="col-12  lg:col-4">
										<label htmlFor="description">
											Logo/Symbol <span style={{ color: "red" }}>*</span>
										</label>{" "}
										<br></br>
										<div style={{ visibility: "hidden" }}>LOGO</div>
										<>
											<Button
												label={form?.logo?.trim().length === 0 ? "Upload" : "Logo Added"}
												onClick={onBtnClick}
												className="p-button-success "
												icon={form?.logo?.trim().length === 0 ? "pi pi-plus" : ""}
											/>
											<input
												ref={inputFileRef}
												type={"file"}
												onChange={(e) => onUploadHandler(e.target)}
												style={{ display: "none" }}
												accept="image/*"
											></input>
										</>
										<br />
										<small style={{ width: "100%" }} className="p-error">
											{formErrorMessage.logo}
										</small>
										<div style={{ visibility: "hidden" }}>LOGO</div>
										{form?.logo?.trim().length === 0 ? (
											""
										) : (
											<Image
												preview={true}
												src={`${form.logo}`}
												alt="Logo"
												width="100px"
												style={{ width: "100px", objectFit: "cover" }}
											/>
										)}
									</div>

									<div className="col-12">



										<GenericFileCapture
											dontClearDocuments={true}
											refresh={refresh} setRefresh={setRefresh}
											key={JSON.stringify(form)}
											extraAttributes={{
												// "candidateID": selectedCanditate.candidateID,
												// "eventID": showCandidateDialog?.event?.eventID
											}}
											documentTypesLookUp={politicalDocumentTypes} show={showFileUploader} setShow={setShowFileUploader}
											setDocuments={setFileUploaderDocuments}
											documents={fileUploaderDocuments}
										/>
										<GenericUploadFileTable
											header={<div className="col-12  lg:col-3 my-2">
												<label htmlFor="description" className="required-input-asterisk">
													Upload Documents
												</label>
												<br />
												<>
													<Button
														label={"Upload"}
														onClick={() => setShowFileUploader(true)}
														className="p-button-success"
														icon={"pi pi-plus"}
													/>
												</>
											</div>}
											setDocuments={setFileUploaderDocuments}
											documents={fileUploaderDocuments}
										/>
										<br />
										{firstSubmit && (<>
											{getMissingCategoryNames().map((e, i) => <div key={i}>
												<span style={{ width: "100%" }} className="p-error">
													{e.name}
												</span>
											</div>)}
										</>)}

									</div>
								</div>

							</TabPanel>
						</TabView>
					</div>
				</div>
			</div>
		</Dialog>
	);
}
